import React, { useEffect, useState } from 'react';
import { getSettings, getSlides, getDocuments, getPartners, getContactsInfo, getSections, trackPageview } from './api';
import './index.css';

import Navbar           from './components/Navbar';
import Ticker           from './components/Ticker';
import HeroSlider       from './components/HeroSlider';
import HeroBlocks       from './components/HeroBlocks';
import Tranches         from './components/Tranches';
import SouscriptionInfo from './components/SouscriptionInfo';
import Partenaires      from './components/Partenaires';
import Impact           from './components/Impact';
import Documents        from './components/Documents';
import ContactsInfo     from './components/ContactsInfo';
import Footer           from './components/Footer';
import Toast            from './components/Toast';

export default function App() {
  const [settings, setSettings]         = useState({});
  const [content, setContent]           = useState({});
  const [slides, setSlides]             = useState([]);
  const [documents, setDocuments]       = useState([]);
  const [partners, setPartners]         = useState([]);
  const [contactsInfo, setContactsInfo] = useState([]);
  const [sections, setSections]         = useState([]);
  const [toast, setToast]               = useState('');

  const showToast = (msg) => { setToast(msg); setTimeout(() => setToast(''), 3500); };

  useEffect(() => {
    trackPageview();
    Promise.all([
      getSettings(), getSlides(), getDocuments(),
      getPartners(), getContactsInfo(), getSections(),
    ])
      .then(([{ settings: s, content: c }, slides, docs, partners, ci, sec]) => {
        setSettings(s); setContent(c); setSlides(slides);
        setDocuments(docs); setPartners(partners);
        setContactsInfo(ci); setSections(sec);

        const root = document.documentElement;
        if (s['color.primary'])      root.style.setProperty('--color-primary', s['color.primary']);
        if (s['color.accent'])       root.style.setProperty('--color-accent', s['color.accent']);
        if (s['color.accent_light']) root.style.setProperty('--color-accent-light', s['color.accent_light']);
        if (s['color.background'])   root.style.setProperty('--color-bg', s['color.background']);
        if (s['color.teal'])         root.style.setProperty('--color-teal', s['color.teal']);

        // Polices dynamiques
        const headingFont = s['font.heading'] || 'Playfair Display';
        const bodyFont    = s['font.body']    || 'DM Sans';
        const FONT_MAP = {
          'Playfair Display':  'Playfair+Display:wght@400;700;900',
          'Cormorant Garamond':'Cormorant+Garamond:wght@400;600;700',
          'EB Garamond':       'EB+Garamond:wght@400;700',
          'Libre Baskerville': 'Libre+Baskerville:wght@400;700',
          'Barlow':            'Barlow:wght@300;400;500;600;700;900',
          'Outfit':            'Outfit:wght@300;400;500;600;700;900',
          'Inter':             'Inter:wght@300;400;500;600;700;900',
          'DM Sans':           'DM+Sans:wght@300;400;500;600',
          'Nunito Sans':       'Nunito+Sans:wght@300;400;600',
          'Source Sans 3':     'Source+Sans+3:wght@300;400;600',
          'Lato':              'Lato:wght@300;400;700',
        };
        [headingFont, bodyFont].forEach(font => {
          const id = `gf-${font.replace(/\s/g,'-')}`;
          if (document.getElementById(id)) return;
          const link = document.createElement('link');
          link.id = id; link.rel = 'stylesheet';
          link.href = `https://fonts.googleapis.com/css2?family=${FONT_MAP[font]||font.replace(/ /g,'+')}&display=swap`;
          document.head.appendChild(link);
        });
        root.style.setProperty('--font-heading', `'${headingFont}', serif`);
        root.style.setProperty('--font-body', `'${bodyFont}', sans-serif`);
        document.body.style.fontFamily = `'${bodyFont}', sans-serif`;

        if (s['seo.title']) document.title = s['seo.title'];
        ['description','keywords'].forEach(k => {
          if (!s[`seo.${k}`]) return;
          let m = document.querySelector(`meta[name="${k}"]`);
          if (!m) { m = document.createElement('meta'); m.name = k; document.head.appendChild(m); }
          m.content = s[`seo.${k}`];
        });
      })
      .catch(console.error);
  }, []);

  const sc = (key) => sections.find(s => s.key === key) || {};

  const SECTION_COMPONENTS = {
    hero:         <React.Fragment key="hero"><HeroSlider slides={slides} settings={settings} content={content.hero||{}} /><HeroBlocks settings={settings} /></React.Fragment>,
    tranches:     <Tranches key="tranches" content={content.tranches||{}} settings={settings} sectionCfg={sc('tranches')} />,
    souscription: <SouscriptionInfo key="souscription" settings={settings} sectionCfg={sc('souscription')} />,
    partenaires:  <Partenaires key="partenaires" partners={partners} settings={settings} sectionCfg={sc('partenaires')} content={content.partenaires||{}} />,
    impact:       <Impact key="impact" content={content.impact||{}} settings={settings} sectionCfg={sc('impact')} />,
    documents:    <Documents key="documents" documents={documents} content={content.documents||{}} settings={settings} sectionCfg={sc('documents')} showToast={showToast} />,
    contacts:     <ContactsInfo key="contacts" contacts={contactsInfo} settings={settings} content={content.contacts||{}} sectionCfg={sc('contacts')} />,
  };

  const orderedSections = sections
    .filter(s => s.active !== 0)
    .sort((a, b) => a.position - b.position);

  return (
    <>
      <Navbar settings={settings} />
      {settings['ticker.active'] !== '0' && <Ticker text={settings['ticker.text']} settings={settings} />}
      {orderedSections.map(s => SECTION_COMPONENTS[s.key] || null)}
      <Footer settings={settings} content={content.footer||{}} />
      <Toast message={toast} />
    </>
  );
}
